import {XStack, YStack} from "@chayka/ui";
import {WpImage} from "@/components";
import {formatNewsDateShort, transformHtml} from "../utils";

interface NewsFeedItemProps {
  image?: number;
  date: string;
  title: string;
  excerpt: string;
  onClick?: () => void;
}

export const NewsFeedItem: React.FC<NewsFeedItemProps> = ({
  image,
  date,
  title,
  excerpt,
  onClick,
}) => {
  return (
    <XStack
      className="gap-3 py-4 border-b border-stroke bg-background cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={onClick}
    >
      {image ? (
        <YStack className="shrink-0 items-center gap-1.5">
          <WpImage imageId={image} alt={title} className="w-20 h-20 rounded-lg object-cover" />
          <p className="text-xs text-secondary-gray">{formatNewsDateShort(date)}</p>
        </YStack>
      ) : null}
      <YStack className="flex-1 gap-2 min-w-0">
        {!image ? <p className="text-xs text-secondary-gray">{formatNewsDateShort(date)}</p> : null}
        <h3 className="text-sm font-bold text-blackout line-clamp-3">{transformHtml(title)}</h3>
        <p className="text-xs text-secondary-gray line-clamp-5">{transformHtml(excerpt)}</p>
      </YStack>
    </XStack>
  );
};
